<div class="volume-viewer" [class.volume-viewer--dragging]="dragging" [class.volume-viewer--overlay]="overlay">
  <div #canvasHost class="volume-viewer__canvas"></div>

  @if (unavailable) {
    <div class="volume-viewer__unavailable">3D view isn't available in this browser.</div>
  }

  @if (closed.observed) {
    <button type="button" class="volume-viewer__close" aria-label="Close 3D view" (click)="closed.emit()">✕</button>
  }

  @if (volumeLabel) {
    <div class="volume-viewer__pill" [class.volume-viewer__pill--shifted]="closed.observed">{{ volumeLabel }}</div>
  }

  @if (noElevation && !unavailable) {
    <div class="volume-viewer__notice">No elevation data</div>
  }

  @if (showLayersToggle && !unavailable) {
    <button type="button" class="volume-viewer__layers" [attr.aria-label]="'Basemap: ' + activeBasemap" (click)="cycleBasemap()">
      {{ basemapShortLabel[activeBasemap] }}
    </button>
  }

  <div class="volume-viewer__compass" aria-hidden="true">
    <div class="volume-viewer__compass-dial" [style.transform]="'rotate(' + (-heading) + 'deg)'">
      <span>N</span>
    </div>
  </div>
</div>
